import {combineReducers} from 'redux';

import reducersTemplate from './reducersTemplate.js';

export default combineReducers({
	// Reducers goes here
	reducersTemplate,
});
